"use strict";

// "use strict";

jQuery(document).ready(function ($) {});